import { i18n } from '@plugins/i18n';

export enum DOCUMENT_CONTENT_TYPE {
    OTHER = 10,
    LECTURE = 20,
    ASSIGNMENT = 30,
    EXAM = 60,
    SUMMARY = 80,
    // PAPERS: 90,
}

export const DOCUMENT_CONTENT_TYPE_VALUES = [
    DOCUMENT_CONTENT_TYPE.OTHER,
    DOCUMENT_CONTENT_TYPE.LECTURE,
    DOCUMENT_CONTENT_TYPE.ASSIGNMENT,
    DOCUMENT_CONTENT_TYPE.EXAM,
    DOCUMENT_CONTENT_TYPE.SUMMARY,
];

export function getContentTypeName(typeId: DOCUMENT_CONTENT_TYPE) {
    return i18n.t(`common:documentTypes.${typeId}`);
}

/**
 * Provides content types with translation. Use this as a computed property in your component.
 * @returns {Array}
 */
export function contentTypeOptions() {
    return DOCUMENT_CONTENT_TYPE_VALUES.map((id) => ({
        id,
        name: getContentTypeName(id),
    }));
}

function getKeyByValue(object: Record<string, unknown>, value: unknown) {
    return Object.keys(object).find((key) => object[key] === value);
}

/**
 * Provides content types of an array of 'indexes'.
 * @param {Array} indexes
 * @returns {Array}
 */
export function getContentTypesValues(indexes = []) {
    return indexes.map((document) => getKeyByValue(DOCUMENT_CONTENT_TYPE, parseInt(document, 10)));
}
